import React from "react";
import ribbonIcon from "../../../assets/icon-ribbon.svg";

import "./styles.css";

export const IconRibbon = () => {
  return <img className="icon-ribbon" src={ribbonIcon} alt="ribbon-icon" />;
};
